module.exports = {
  percentage: "percentage",
  fixed: "fixed",
  percentageRounded: "percentageRounded",
  fixedRounded: "fixedRounded",
};
